import type { Concept, Annotation, Note } from '@verantos-dev/core-annotation-tool';
import {
  useNoteSectionCore,
  type UseNoteSectionCoreResult,
} from '@verantos-dev/core-annotation-tool';

import {
  selectAddEvidenceModeForConceptId,
  selectHighlightedTextSpans,
  selectPendingSpansForAnnotation,
  selectSelectedNoteId,
} from '../../../state/selector';
import {
  addPendingSpan,
  addHighlightedTextSpan,
  clearAddEvidenceModeForConceptId,
} from '../../../state/supervisorSlice';

export type UseNoteSectionSupervisorResult = UseNoteSectionCoreResult;

interface UseNoteSectionSupervisorProps {
  concepts: Concept[] | null;
  annotations: Annotation[] | null;
  selectedNote: Note | null;
}

export const useNoteSectionSupervisor = ({
  concepts,
  annotations,
  selectedNote,
}: UseNoteSectionSupervisorProps): UseNoteSectionSupervisorResult => {
  return useNoteSectionCore({
    concepts,
    annotations,
    selectedNote,
    selectors: {
      selectAddEvidenceModeForConceptId,
      selectHighlightedTextSpans,
      selectPendingSpansForAnnotation,
      selectSelectedNoteId,
    },
    actions: {
      addPendingSpan,
      addHighlightedTextSpan,
      clearAddEvidenceModeForConceptId,
    },
  });
};
